import React from 'react';
import { createAction } from '../../utils/createAction';

export const useAuth = () => {
  const [reducerState, dispatch] = React.useReducer(
    (state: any, action: { type: string; payload: any }) => {
      switch (action.type) {
        case 'SET_USER':
          if(action.payload.email){
          localStorage.setItem("USER", action.payload.email)}
          // console.log(action.payload.email);
          return {
            ...state,
            user: { ...action.payload },
          };
        case 'USER_EXISTS':
          if(action.payload.userExistence){
          localStorage.setItem("USER_EXISTS",action.payload.userExistence)}
          // console.log(action.payload.userExistence);
          return {
            ...state,
            userExists: { ...action.payload.userExistence },
          };
        case 'REMOVE_USER':
          localStorage.setItem("USER", '');
          return {
            ...state,
            user: undefined,
            userExists: false,
          };
        default:
          return state;
      }
    },
    {
      user: localStorage.getItem("USER")|| undefined,
      mobileVerified: undefined,
      loading: true,
    }
  );

  const auth = React.useMemo(
    () => ({
      addUser: async (email: string) => {
        const user = {
          email,
        };
        dispatch(createAction('SET_USER', user));
      },
      userExist: async (userExistence: boolean)=>{
        dispatch(createAction('USER_EXISTS',userExistence));
      },
      removeUser: async () => {
        dispatch(createAction('REMOVE_USER'));
      },
    }),
    []
  );

  return { auth, state: reducerState };
};
